import React from "react";
import {
  useGetEventOrganizationProfileForDisplay,
  useGetOrganizationProfileForDisplay,
  useGetProfileForDisplay
} from "./dataloader";
import { OrganizationInfo, ParticipantInfo, ViewProfileProps } from "./types";
import useGetViewProfileTabs from "./useGetViewProfileTabs";
import { ViewProfileService } from "./types";
import { getSchemaFieldsForDisplayProfile } from "./utils";

export function useGetOrganizationProfile(props: ViewProfileProps) {
  const { data: programOrganization } = useGetOrganizationProfileForDisplay({
    programOrganizationId: props.entityId,
    viewerProgramParticipantId: props.viewerProgramParticipantId,
    viewerEventParticipantId: props.viewerEventParticipantId,
    errorHandler: props.closeHandler,
    contextEntityType: props.contextEntityType
  });

  const { data: eventOrganization } = useGetEventOrganizationProfileForDisplay({
    eventOrganizationId: props.entityId,
    viewerProgramParticipantId: props.viewerProgramParticipantId,
    viewerEventParticipantId: props.viewerEventParticipantId,
    errorHandler: props.closeHandler,
    contextEntityType: props.contextEntityType,
    viewType: props.eventOrganizationViewType
  });
  return programOrganization || eventOrganization;
}

export default function useViewProfileService(props: ViewProfileProps): ViewProfileService {
  const [activeTabId, setActiveTabId] = React.useState<string>();
  const { data: participantProfileDetails } = useGetProfileForDisplay({
    programParticipantId: props.entityId,
    viewerProgramParticipantId: props.viewerProgramParticipantId,
    viewerEventParticipantId: props.viewerEventParticipantId,
    errorHandler: props.closeHandler,
    contextEntityType: props.contextEntityType,
    customApi: props.customApi
  });

  const organizationProfileDetails = useGetOrganizationProfile(props);

  const schemaList = React.useMemo(() => {
    if (organizationProfileDetails) {
      return organizationProfileDetails.profile;
    } else if (participantProfileDetails) {
      return participantProfileDetails.profile;
    }
    return [];
  }, [organizationProfileDetails, participantProfileDetails]);

  const profileSchema = React.useMemo(() => {
    return getSchemaFieldsForDisplayProfile(schemaList);
  }, [schemaList]);

  const { tabsList } = useGetViewProfileTabs({
    contextEntityType: props.contextEntityType,
    profile: profileSchema,
    products: organizationProfileDetails?.productProfiles,
    organizationPlatformFields: organizationProfileDetails?.platformFieldsProfile
  });

  const profilePictureLocation = React.useMemo(
    () => participantProfileDetails?.profilePictureLocation,
    [participantProfileDetails?.profilePictureLocation]
  );

  const participantInfo = React.useMemo(() => {
    return participantProfileDetails?.platformFieldsProfile as ParticipantInfo;
  }, [participantProfileDetails?.platformFieldsProfile]);

  const organizationInfo = React.useMemo(() => {
    return organizationProfileDetails?.platformFieldsProfile as OrganizationInfo;
  }, [organizationProfileDetails?.platformFieldsProfile]);

  return {
    profileSchema,
    profilePictureLocation,
    participantInfo,
    participantProfileDetails,
    organizationProfileDetails,
    tabsList,
    organizationInfo,
    activeTabId,
    setActiveTabId
  };
}
